/**
 * The SAS mode choice (Ad-hoc / Stored policy). Last UI/UX pass (Codex Z6): an unavailable Stored policy mode shows its
 * reason as a line under the group — as the Kind group does (`SasKindFields`) — and the group and the disabled radio
 * name that line with `aria-describedby`; it used to live only in a hover title, which keyboard users never see.
 */
import { useId } from 'react';
import { RadioGroup, RadioGroupItem } from '../../../../../../components/ui/radio-group';

export type SasMode = 'ad-hoc' | 'policy';

export function SasModeFields({ value, policyReason, onChange }: { value: SasMode; policyReason?: string; onChange: (mode: SasMode) => void }) {
  const reasonId = useId();
  const describedBy = policyReason ? reasonId : undefined;
  return (
    <fieldset>
      <legend className="text-sm font-medium">Mode</legend>
      {/* U40 (A+B merge): the shared RadioGroup, not native radios. */}
      <RadioGroup value={value} onValueChange={(mode) => onChange(mode as SasMode)} aria-label="Mode" aria-describedby={describedBy} className="mt-1 flex flex-wrap gap-x-4 gap-y-1">
        <label className="flex items-center gap-1.5 text-sm"><RadioGroupItem value="ad-hoc" aria-label="Ad-hoc" /> Ad-hoc</label>
        <label className="flex items-center gap-1.5 text-sm" title={policyReason}>
          <RadioGroupItem value="policy" aria-label="Stored policy" title={policyReason} disabled={!!policyReason} aria-describedby={describedBy} /> Stored policy
        </label>
      </RadioGroup>
      {policyReason && (
        <p id={reasonId} className="mt-1 text-xs text-muted-foreground" data-testid="storage-sas-mode-reason">
          <span className="font-medium">Stored policy</span> is not available: {policyReason}
        </p>
      )}
    </fieldset>
  );
}
